module.exports = __webpack_public_path__ + "fonts/iranyekanwebmediumfanum.9c78b97.woff";